import React from 'react';
import { Mark } from './Mark';
import { PeekEgg } from './PeekEgg';

const VERSION = 'v0.8.0';
const LAST_UPDATED = '2026-07-15';

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="footer__mark">
        <Mark size={20} />
        <span>Berti</span>
      </div>
      <div className="footer__copy">© {year} · evenstarmusic.com</div>

      <a
        className="footer__qr"
        href={`${process.env.PUBLIC_URL}/images/qr/evenstarmusic-qr.svg`}
        download
        title="Save the QR code (SVG) — for business cards, flyers, or sharing"
      >
        <img
          src={`${process.env.PUBLIC_URL}/images/qr/evenstarmusic-qr.png`}
          alt="QR code linking to evenstarmusic.com"
          width={76}
          height={76}
          loading="lazy"
        />
        <span className="footer__qr-cap">Scan to visit · tap to save</span>
      </a>

      <div className="footer__version">{VERSION} · last updated {LAST_UPDATED}</div>
      <div className="footer__egg">Site design by Johnny Blastoff 🚀</div>
      <PeekEgg />
    </footer>
  );
}
